import React from 'react';
import './styles.less';

const DynamicQuestions = ({dynamicQuestions}) => {
    if (!dynamicQuestions || dynamicQuestions.length === 0) {
        return null;
    }

    const questions = dynamicQuestions
        .filter(({heading, intro}) => heading && intro)
        .map(({heading, intro, answer, outro}, i) => {
            return (
                <div
                    className={'col-md-12'}
                    key={`q${i}`}
                    itemScope
                    itemProp={'mainEntity'}
                    itemType={'https://schema.org/Question'}
                >
                    <h3 itemProp={'name'}>{heading}</h3>
                    <div
                        itemScope
                        itemProp={'acceptedAnswer'}
                        itemType={'https://schema.org/Answer'}
                    >
                        <div itemProp={'text'}>
                            <p>{intro}</p>
                            {answer && answer.length > 0 && (
                                <ul className={'dynamic-answers'}>
                                    {answer.map((item, j) => (
                                        <li key={`q${i}a${j}`}> {item} </li>
                                    ))}
                                </ul>
                            )}
                            {outro && <p>{outro}</p>}
                        </div>
                    </div>
                </div>
            );
        });

    if (questions.length === 0) return null;

    return (
        <div
            className={'container module dynamic-questions'}
            itemScope
            itemType={'https://schema.org/FAQPage'}
        >
            <div className={'row'}>{questions}</div>
        </div>
    );
};

export default DynamicQuestions;
